const headerDataEditorHP = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "HPCode",
    label: "客户编号",
    columnwidth: 120,
  },
  {
    prop: "HPName",
    label: "客户名称",
    columnwidth: 220,
  },
  {
    prop: "AuthorizeStatusName",
    label: "授权状态",
    columnwidth: 80,
  },
  {
    prop: "Province",
    label: "省份",
    columnwidth: 80,
  },
  {
    prop: "City",
    label: "市",
    columnwidth: 80,
  },
  {
    prop: "District",
    label: "区",
    columnwidth: 80,
  },
  {
    prop: "Address",
    label: "地址",
    columnwidth: 180,
  },
  {
    prop: "HosType",
    label: "客户分类",
    columnwidth: 80,
  },
  {
    prop: "TechnicalOffices",
    label: "科室",
    columnwidth: 100,
  },
  {
    prop: "Doctor",
    label: "医生",
    columnwidth: 100,
  },
  {
    prop: "SurgeryType",
    label: "手术类型",
    columnwidth: 100,
  },
  {
    prop: "SalesMan",
    label: "销售人员",
    columnwidth: 100,
  },
  {
    prop: "PSalesMan",
    label: "销售人员上级",
    columnwidth: 100,
  },
  {
    prop: "PPSalesMan",
    label: "销售人员上上级",
    columnwidth: 100,
  },
  {
    prop: "CreatorName",
    label: "创建人",
    columnwidth: 130,
  },
  {
    prop: "CreateTime",
    label: "创建时间",
    columnwidth: 130,
  },
  {
    prop: "Updater",
    label: "修改人",
    columnwidth: 130,
  },
  {
    prop: "UpdateTime",
    label: "修改时间",
    columnwidth: 130,
  },
];
export default headerDataEditorHP;
